import { gql } from '@apollo/client'

const PARTNERS_FIELDS = gql`
  fragment PartnersFields on Partner {
    id
    hashId
    name
    salesforceCustomerId
    slug
    partnerType
  }
`
const PARTNER_FIELDS = gql`
  fragment PartnerFields on Partner {
    id
    hashId
    name
    salesforceCustomerId
    slug
    partnerType
    dateFormat
    domains
    domainOnboarding
    welcomeEmailDate
    overrideWelcomeEmail
    terminationDate
    logo
    enrollmentOptimization
    eligibilityMethod
  }
`

const PROGRAM_BENEFIT_FIELDS = gql`
  fragment ProgramBenefitFields on ProgramBenefit {
    id
    country
    subscriptionType
    userPaysRaw
    partnerPaysRaw
    discountRaw
    currency
    benefit {
      id
      name
      subscriptionType
      retailRates {
        country
        retailRateInCents
        currency
      }
    }
    program {
      id
      monthsInactiveUntilSnooze
    }
  }
`

const PROGRAM_FIELDS = gql`
  ${PROGRAM_BENEFIT_FIELDS}
  fragment ProgramFields on Program {
    id
    name
    slug
    partnerHashId
    monthsInactiveUntilSnooze
    activePayStartDate
    discountCode
    programBenefits {
      ...ProgramBenefitFields
    }
  }
`

const CONTACT_FIELDS = gql`
  fragment ContactFields on Contact {
    id
    firstName
    lastName
    emailAddress
    sftpNotification
  }
`

const PARTNER_WITH_CONTACTS_FIELDS = gql`
  ${PARTNER_FIELDS}
  ${CONTACT_FIELDS}
  ${PROGRAM_FIELDS}
  fragment PartnerWithContactFields on Partner {
    ...PartnerFields
    program {
      ...ProgramFields
    }
    contacts {
      ...ContactFields
    }
  }
`

export { CONTACT_FIELDS, PARTNER_FIELDS, PARTNER_WITH_CONTACTS_FIELDS, PARTNERS_FIELDS }
